// extracted by mini-css-extract-plugin
export default {"root":"Register_root__cjtOE","title":"Register_title__HiLtJ"};